import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 40,
    width: 40,
    [theme.breakpoints.down('md')]: {
      height: 36,
      width: 36
    }
  },
  avatarBorder: {
    border: 'solid 2px white'
  },
  marginLeft: {
    zIndex: 1,
    marginLeft: '-16px'
  }
}))

export default useStyles
